import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import UserAgentMixin from '@/helpers/mixins/UserAgentMixin';
let AffiliateMixin = class AffiliateMixin extends Mixins(UserAgentMixin) {
    get affiliateCode() {
        return this.$router.currentRoute.query.affiliate_code;
    }
    initializeLink(code) {
        const { origin } = window.location;
        if (code) {
            this.goToSignIn(`${origin}/login/client?affiliate_code=${code}`);
        }
        else {
            this.goToSignIn(`${origin}/login/client`);
        }
    }
    get inSalesPage() {
        return this.$route.name === 'sales';
    }
};
AffiliateMixin = __decorate([
    Component
], AffiliateMixin);
export default AffiliateMixin;
